import { Component } from '@angular/core';
import { SeoService } from '../core/service/seo.service';

@Component({
  selector: 'app-impressum',
  standalone: true,
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.css'],
})
export class ImpressumComponent {
  constructor(private seoService: SeoService) {}

  ngOnInit(): void {
    this.seoService.updateMetaTag(
      'description',
      'Erfahren Sie mehr über uns. Hier finden Sie unser Impressum mit allen wichtigen ' +
        'Informationen zu unserem Unternehmen und unseren rechtlichen Hinweisen.',
    );
    this.seoService.createLinkForCanonicalURL('/impressum');
  }
}
